import { NavLink } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../context/AuthContext.jsx";
import { useDraftPrompt } from "../context/DraftPromptContext.jsx";

export default function Sidebar({ currentPage = "", isOpen = true }) {
  const [marketingOpen, setMarketingOpen] = useState(
    [
      "social-media",
      "captions",
      "images",
      "reels",
      "templates",
      "stories",
      "emails",
      "emails-lead-magnet",
      "emails-sale-campaign",
      "emails-social-template",
      "courses",
      "blueprints",
      "events",
      "content-vault",
      "carousels",
      "videos",
      "all-bonuses"
    ].includes(currentPage),
  );

  const { user, admin, manager } = useAuth();
  const { state } = useDraftPrompt();

  const hasContent =
    state.content?.trim() || (state.items && state.items.length > 0);

  const handleChatOpen = () => {
    if (!user) return;

    window.intercomSettings = {
      api_base: "https://api-iam.intercom.io",
      app_id: "y6mok9r1",
      name: user.name || "",
      email: user.email || "",
      user_id: user.itercomiduser || "",
      user_hash: user.intercomuserhash || "",
      created_at: Math.floor(Date.now() / 1000),
    };

    (function () {
      const w = window;
      const ic = w.Intercom;

      if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
      } else {
        const d = document;
        const i = function () {
          i.c(arguments);
        };

        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };

        w.Intercom = i;

        const l = function () {
          if (document.getElementById("intercom-widget-script")) return;

          const s = d.createElement("script");
          s.id = "intercom-widget-script";
          s.type = "text/javascript";
          s.async = true;
          s.src = "https://widget.intercom.io/widget/y6mok9r1";

          const x = d.getElementsByTagName("script")[0];
          x.parentNode.insertBefore(s, x);
        };

        if (document.readyState === "complete") {
          l();
        } else if (w.attachEvent) {
          w.attachEvent("onload", l);
        } else {
          w.addEventListener("load", l, false);
        }
      }
    })();

    if (window.Intercom) {
      window.Intercom("show");
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <aside
      className={`col-2 sidebar border-end bg-secondary-light ${
        isOpen ? "desktop" : ""
      }`}
    >
      <div className="d-flex flex-column min-vh-100 sticky-top p-2">
        <div className="mb-auto mb-0 pt-4 mt-5">
          {user.limitedexperience == null ? (
            <>
              <button
                type="button"
                className="btn btn-primary w-100 mb-2 text-start"
                id="draft-prompt-button"
                onClick={() => window._draft_prompt_open?.()}
              >
                {hasContent ? "Continue Post" : "Create New Post"}
              </button>

              <NavLink
                to="/for-you"
                className={`nav-link${currentPage === "for-you" ? " active" : ""}`}
              >
                <i className="fi fi-rr-rocket-lunch"></i>
                <span>For You</span>
              </NavLink>

              <NavLink
                to="/my-calendar"
                className={`nav-link${
                  currentPage === "my-calendar" ? " active" : ""
                }`}
              >
                <i className="fi fi-rr-calendar"></i>
                <span>My Calendar</span>
              </NavLink>

              <NavLink
                to="/my-media"
                className={`nav-link${currentPage === "my-media" ? " active" : ""}`}
              >
                <i className="fi fi-rr-picture"></i>
                <span>My Media</span>
              </NavLink>

              <NavLink
                to="/my-drafts?my-drafts"
                className={`nav-link${
                  currentPage === "my-drafts" ? " active" : ""
                }`}
              >
                <i className="fi fi-rr-edit"></i>
                <span>My Drafts</span>
              </NavLink>

              <NavLink
                to="/my-favorites"
                className={`nav-link${
                  currentPage === "my-favorites" ? " active" : ""
                }`}
              >
                <i className="fi fi-rr-heart"></i>
                <span>My Favorites</span>
              </NavLink>

              <button
                type="button"
                className="nav-link w-100 text-start"
                onClick={() => setMarketingOpen(!marketingOpen)}
              >
                <i className="fi fi-rr-megaphone"></i>
                <span>Marketing</span>
              </button>

              <div className={`collapse${marketingOpen ? " show" : ""}`}>
                <NavLink
                  to="/social-media"
                  className={`nav-link ps-4 ${
                    [
                      "content-vault",
                      "social-media",
                      "captions",
                      "images",
                      "reels",
                      "templates",
                      "videos",
                      "stories",
                      "carousels",
                      "all-bonuses",
                    ].includes(currentPage)
                      ? " active"
                      : ""
                  }`}
                >
                  <i className="fi fi-rr-calendar-day"></i>
                  <span>Social Media</span>
                </NavLink>

                <NavLink
                  to="/emails"
                  className={`nav-link ps-4 ${
                    [
                      "emails",
                      "emails-lead-magnet",
                      "emails-sale-campaign",
                      "emails-social-template",
                    ].includes(currentPage)
                      ? " active"
                      : ""
                  }`}
                >
                  <i className="fi fi-rr-envelope"></i>
                  <span>Email Marketing</span>
                </NavLink>

                <NavLink
                  to="/courses"
                  className={`nav-link ps-4${
                    ["courses", "blueprints", "events"].includes(currentPage)
                      ? " active"
                      : ""
                  }`}
                >
                  <i className="fi fi-rr-graduation-cap"></i>
                  <span>Business Class</span>
                </NavLink>
              </div>
            </>
          ) : user.limitedexperience == 2 ? (
            <>
              <NavLink
                to="/emails"
                className={`nav-link${
                  [
                    "emails",
                    "emails-lead-magnet",
                    "emails-sale-campaign",
                    "emails-social-template",
                  ].includes(currentPage)
                    ? " active"
                    : ""
                }`}
              >
                <i className="fi fi-rr-envelope"></i>
                <span>Email Marketing</span>
              </NavLink>  
            </>
          ) : (
            <>
              <NavLink
                to="/stories"
                className={`nav-link${currentPage === "stories" || currentPage === "carousels" || currentPage === "reels" || currentPage === "content-vault" ? " active" : ""}`}
              >
                <i className="fi fi-rr-template"></i>
                <span>Templates</span>
              </NavLink>

              <NavLink
                to="/my-favorites"
                className={`nav-link${currentPage === "my-favorites" ? " active" : ""}`}
              >
                <i className="fi fi-rr-heart"></i>
                <span>My Favorites</span>
              </NavLink>
            </>
          )}

          <a
            className="nav-link"
            href="https://platform.socialjet.ai/community/"
            target="_new"
          >
            <i className="fi fi-rr-users-alt"></i>
            <span>Community</span>
          </a>

          <button
            type="button"
            className="nav-link w-100 text-start border-0 bg-transparent"
            onClick={handleChatOpen}
          >
            <i className="fi fi-rr-comment"></i>
            <span>Chat Support</span>
          </button>

          {manager && (
            <a
              href="https://platform.socialjet.ai/app/panel-social-media-manager"
              className="nav-link"
            >
              <i className="fi fi-rr-users"></i>
              <span>Media Manager</span>
            </a>
          )}

          {admin && (
            <a
              href="https://platform.socialjet.ai/app/panel-home"
              className="nav-link"
            >
              <i className="fi fi-rr-settings-sliders"></i>
              <span>Admin Panel</span>
            </a>
          )}
        </div>
        {user.limitedexperience == null ? (
          <div className="pb-3">
            <div className="bg-primary-light p-3 rounded-4">
              <h6 className="fw-bold text-dark mb-3">⚡️ Trending Topics</h6>

              <a
                className="d-inline-block text-decoration-none text-muted mb-2"
                target="_blank"
                rel="noreferrer"
                href="https://help.travelagentcollective.com/en/articles/10546949-link-your-canva-account-to-tac"
              >
                <span
                  className="bg-light rounded-circle d-inline-block text-center text-primary fw-bold me-2"
                  style={{ width: "22px" }}
                >
                  1
                </span>
                Link your Canva
              </a>

              <a
                className="d-inline-block text-decoration-none text-muted mb-2"
                target="_blank"
                rel="noreferrer"
                href="https://help.travelagentcollective.com/en/collections/6632475-social-media"
              >
                <span
                  className="bg-light rounded-circle d-inline-block text-center text-primary fw-bold me-2"
                  style={{ width: "22px" }}
                >
                  2
                </span>
                Social Media
              </a>

              <a
                className="d-inline-block text-decoration-none text-muted mb-2"
                target="_blank"
                rel="noreferrer"
                href="https://help.travelagentcollective.com/en/collections/10624982-email-marketing"
              >
                <span
                  className="bg-light rounded-circle d-inline-block text-center text-primary fw-bold me-2"
                  style={{ width: "22px" }}
                >
                  3
                </span>
                Email Marketing
              </a>

              <a
                className="d-inline-block text-decoration-none text-muted"
                target="_blank"
                rel="noreferrer"
                href="https://help.travelagentcollective.com/en/collections/3457093-getting-started"
              >
                <span
                  className="bg-light rounded-circle d-inline-block text-center text-primary fw-bold me-2"
                  style={{ width: "22px" }}
                >
                  4
                </span>
                Getting Started
              </a>
            </div>
          </div>
        ) : null}
      </div>
    </aside>
  );
}